import React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

export const NpiMask = React.forwardRef(({ name, onChange, ...props }, ref) => (
  <IMaskInput
    {...props}
    mask="##########"
    definitions={{ '#': /[0-9]/ }}
    inputRef={ref}
    onChange={onChange}
    overwrite
  />
));

NpiMask.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
};
